import { ContentKindList } from "@pdfking/templates"
import type { ContentRenderer } from "@pdfking/templates"
import { RecordCreate, Values } from "@pdfking/tfunc"

import { DjSelect } from "../forms/fields/DjSelect"
import { useTranslation, useTranslationTyped } from "../i18n/useTranslation"

// What the generated content draws as, picked like any choice field among
// the templates' content kinds, named as the templates translate them: the
// blank one lets go of it, each grow drawn as its own again.
export function ContentControl({
  value,
  on_value,
}: {
  value: ContentRenderer | undefined
  on_value: (content: ContentRenderer | undefined) => void
}) {
  const pdfview = useTranslationTyped("pdfview")
  const content = useTranslation("content")
  const choices = RecordCreate([
    ["", "-"],
    ...Values(ContentKindList).map(({ id, name }) => [id, content[name]!()] as const),
  ])
  return (
    <div className="flex flex-col gap-1 px-1">
      <label className="text-sm font-medium" htmlFor="pdfview-content">
        {pdfview.CONTENT()}
      </label>
      <DjSelect
        choices={choices}
        dom_id="pdfview-content"
        input={value ?? ""}
        onselect={next => on_value((next || undefined) as ContentRenderer | undefined)}
      />
    </div>
  )
}
